import { get as getCookie, set as setCookie } from 'js/lib/cookie';
import { get as getUser, isCourserian } from 'js/lib/user';

import EpicClient from 'bundles/epic/clients/siteMisc';

export const COLOR_SCHEME_PREFERENCE_COOKIE = 'colorTheme';

export type ColorSchemePreference = 'light' | 'dark' | 'system';

export const getColorSchemePreference = () => {
  return getCookie(COLOR_SCHEME_PREFERENCE_COOKIE);
};

export const setColorSchemePreference = (preference: ColorSchemePreference) => {
  setCookie(COLOR_SCHEME_PREFERENCE_COOKIE, preference);
};

export const enableAppearancePreferences = () => {
  const userId = getUser()?.id;
  const enableForCourserians = isCourserian() && EpicClient.get('allowDarkMode');
  const enableForDogfooding = (EpicClient.get('allowDarkModeByUserId') ?? []).includes(userId);
  return enableForCourserians || enableForDogfooding;
};
